import React from "react";

const CheckboxPicklistDisplay = (props) => {
    if (!props.selections) {
        return null;
    }

    const displaySelections = props.selections.map((s) => (
        <div key={`selection_${s.value}`} className="selected-item">
            {s.text}
        </div>
    ));

    return <div>{displaySelections}</div>;
};

export default CheckboxPicklistDisplay;
